'use strict';

require("moduleFold/notifiche/scripts/index.js");
require("moduleFold/datasource/scripts/index.js");
var BssBasicField = require("moduleFold/formbuilder/scripts/mixins/BssBasicField");


/**
 * Campo di tipo entity su entity esterna
 * 
 * @class  
 * @param {type} formlyConfig
 * @param {type} formlyValidationMessages
 * @param {Valida} Valida
 */
function BSSMultiselect(formlyConfig, formlyValidationMessages, Valida){
    formlyConfig.setType($.extend(true, {}, new BssBasicField(), {
        name: 'bssmultiselect', 
        extends: 'bssselect',
        template: require("./bssmultiselect.html"),
        controller: ["$scope", "$filter", "$timeout", "$http", "ErrorManager", "DSFactory", "$rootScope", require("./BssMultiselectController")],
        defaultOptions: {
            ngModelElAttrs: {
                'cssCategory': 'bssmultiselect'
            },
        }
    }));
}

module.exports = BSSMultiselect;